export default "__VITE_ASSET__C5Z_VDOx__"